import { render, staticRenderFns } from "./SuperClienteClienteSelectComponent.vue?vue&type=template&id=567adf0b&scoped=true&"
import script from "./SuperClienteClienteSelectComponent.vue?vue&type=script&lang=js&"
export * from "./SuperClienteClienteSelectComponent.vue?vue&type=script&lang=js&"
import style0 from "./SuperClienteClienteSelectComponent.vue?vue&type=style&index=0&id=567adf0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567adf0b",
  null
  
)

export default component.exports